<div [class]="'add-btn-shared lato-'+textSize+'-'+textWeight+'-vw'"
  [ngStyle]="{'width':buttonWidth}">
  <div class='add-icon txt-white abs-centre' [ngStyle]="{'width':circleSize , 'height':circleSize}"
    cygovSvgIcon [svgName]="'add-icon'"></div>
  <span class="title-txt" [ngStyle]="{'color':textColor}">{{titleName}}</span>
</div>